// eslint-disable-next-line new-cap
export default({
  dateAfters: (date, afters) => {
    date.setDate(date.getDate() + afters)
    return date
  }/** 加天数 */,
  hhPlus: (date, afters) => {
    date.setHours(date.getHours() + afters)
    return date
  }/** 加小时 */,
  getMMDD2: (date) => {
    var m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)// 获取当前月份的日期，不足10补0
    var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()// 获取当前几号，不足10补0
    return m + '' + d
  }/** 月 日 */,
  getMMDD: (date) => {
    var m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)// 获取当前月份的日期，不足10补0
    var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()// 获取当前几号，不足10补0
    return m + '-' + d
  }/** 月-日 */,
  getWeekDay: (i) => {
    var ddd = '日'
    if (i === 1) ddd = '一'
    if (i === 2) ddd = '二'
    if (i === 3) ddd = '三'
    if (i === 4) ddd = '四'
    if (i === 5) ddd = '五'
    if (i === 6) ddd = '六'
    return '周' + ddd
  },
  dtFmt: (value, fmt) => {
    if (typeof (value) === 'undefined' || value === null || value === '') {
      return null
    } else {
      var date = new Date(value)
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var hh = date.getHours()
      hh = (hh < 10 ? '0' + hh : hh)
      var mm = date.getMinutes()
      mm = (mm < 10 ? '0' + mm : mm)
      if (fmt === 'HHmm') {
        return hh + ':' + mm
      }
      var ss = date.getSeconds()
      if (fmt === 'HHmmss') {
        return hh + ':' + mm + ':' + ss
      }
      var day = date.getDate().toString()
      if (month < 10) {
        month = '0' + month
      }
      if (fmt === 'yyM') {
        return year + '-' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      if (fmt === 'mdhm') {
        return month + '-' + day + ' ' + hh + ':' + mm
      }
      if (fmt === 'mmdd') {
        return month + '/' + day
      }
      if (fmt === 'md') {
        return month + '月' + day + '日'
      }
      var i = date.getDay()
      var ddd = '日'
      if (i === 1) ddd = '一'
      if (i === 2) ddd = '二'
      if (i === 3) ddd = '三'
      if (i === 4) ddd = '四'
      if (i === 5) ddd = '五'
      if (i === 6) ddd = '六'
      if (fmt === 'ddHH') {
        return month + '/' + day + '周' + ddd + ' ' + hh + ':' + mm
      }
      if (fmt === 'yyHH') {
        return year + '/' + month + '/' + day + '周' + ddd + ' ' + hh + ':' + mm
      }
      if (fmt === 'ymd') {
        return year.substring(2, 4) + '' + month + '' + day
      }
      if (fmt === 'yyss') {
        return year + '-' + month + '-' + day + 'T' + hh + ':' + mm
      }
      if (fmt === '--') {
        return year + '-' + month + '-' + day
      }
      return year + '-' + month + '-' + day + ' ' + hh + ':' + mm + ':' + ss
    }
  },
  dateFmt: (value, abb) => {
    if (typeof (value) === 'undefined' || value === null || value === '') {
      return ''
    } else {
      var date = new Date(value)
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      if (abb) return year + '/' + month + '/' + day
      else return year + '-' + month + '-' + day
    }
  },
  dtDiff: (dtStart, dtEnd, dtMM) => { // ss,mm,hh,dd
    // console.log(`utils.dateUtil.dtDiff /n dt1:${dtStart} /n dt2:${dtEnd} /n mm:${dtMM}`)
    // console.log('dtUtil.dtDiff.1', typeof (dtStart))
    if (typeof (dtStart) === 'undefined' || dtStart === null || dtStart === '') {
      return -1
    }
    if (typeof (dtEnd) === 'undefined' || dtEnd === null || dtEnd === '') {
      return -1
    }
    let dt1 = 0
    if (typeof (dtStart) === 'string')dt1 = (new Date(dtStart)).getTime()
    else dt1 = dtStart.getTime()

    let dt2 = 0
    if (typeof (dtEnd) === 'string')dt2 = (new Date(dtEnd)).getTime()
    else dt2 = dtEnd.getTime()
    let rs = 0
    if (dtMM === 'ss') rs = (dt2 - dt1) / 1000
    else if (dtMM === 'mm') rs = (dt2 - dt1) / 1000 / 60
    else if (dtMM === 'hh') rs = (dt2 - dt1) / 1000 / 60 / 60
    else if (dtMM === 'dd') rs = (dt2 - dt1) / 1000 / 60 / 60 / 24
    return rs
  },
  msFmt: (sec) => {
    console.log('---------dateUtil.msFmt----------')
    console.log(sec)
    let hour = Math.floor(sec / 3600)
    let minute = Math.floor((sec - hour * 3600) / 60)
    let second = sec - hour * 3600 - minute * 60
    if (hour < 10) {
      hour = '0' + hour
    }
    if (minute < 10) {
      minute = '0' + minute
    }
    if (second < 10) {
      second = '0' + second
    }
    return /* hour + ":" +*/ minute + ':' + second
  },
  dtCompare: (dt1Long, dt2) => {
    if (!dt2)dt2 = new Date()
    // console.log('dateUtil.dtCompare.1' + dt1Long)
    // console.log('dateUtil.dtCompare.2' + dt2)
    return dt1Long > dt2.getTime()
  },
  dateDiff: (date1, date2) => {
    var timesDiff = Math.abs(date1.getTime() - date2.getTime())
    var diffDays = Math.ceil(timesDiff / (1000 * 60 * 60 * 24))// 向上取整
    return diffDays
  },
  dayDiff: (date1, date2) => {
    var timesDiff = Math.abs(date1 - date2)
    var diffDays = Math.ceil(timesDiff / (1000 * 60 * 60 * 24))// 向上取整
    return diffDays
  },
  dateEasyUIFormat: (value, type) => {
    if (typeof (value) === 'undefined') {
      return ''
    } else {
      var date = new Date(value)
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return month + '/' + day + '/' + year
    }
  },
  dateEasyUILong: (value, type) => {
    if (typeof (value) === 'undefined') {
      return ''
    } else {
      var date = new Date(value)
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      var hour = date.getHours().toString()
      var minutes = date.getMinutes().toString()
      var seconds = date.getSeconds().toString()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      if (hour < 10) {
        hour = '0' + hour
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return month + '/' + day + '/' + year + ' ' + hour + ':' + minutes + ':' + seconds
    }
  },
  ssFormat: (sec) => {
    let hour = Math.floor(sec / 3600)
    let minute = Math.floor((sec - hour * 3600) / 60)
    let second = sec - hour * 3600 - minute * 60
    if (hour < 10) {
      hour = '0' + hour
    }
    if (minute < 10) {
      minute = '0' + minute
    }
    if (second < 10) {
      second = '0' + second
    }
    return (hour > 0 ? hour + ':' : '') + minute + ':' + second
  },
  toSeconds(dt) {
    return dt.getHours() * 60 * 60 + dt.getMinutes() * 60 + dt.getSeconds()
  }
})



// WEBPACK FOOTER //
// ./src/utils/dateUtil.js